const registerUserDictIT = {
  referralUsername: "Nome utente di riferimento",
  nameOfUserRefferalCodeInvalid: "Nome utente di riferimento non valido.",
  doYouHave: "Hai un riferimento?",
  iHaveReferral: "Ho un riferimento",
  yes: "Sì",
  no: "No",
  voucher: "Codice voucher",
  doYouHaveVoucher: "Hai un voucher?",
  username: "Nome utente",
  password: "Password",
  confirmPassword: "Conferma password",
  fullName: "Nome e Cognome",
  firstName: "Nome di battesimo",
  surname: "Cognome",
  documentNumber: "Codice Fiscale",
  documentNumberPJ: "Partita IVA",
  selectCurrency: "Seleziona una valuta",
  terms: "Accetto i termini e le condizioni.",
  marketingEmail: "Ricevere email su aggiornamenti e promozioni?",
  recaptcha: "Ricontrolla ReCaptcha",
  signUp: "Iscrizione",
  proceedToPayment: "Procedere al Pagamento",
  payWithExtracoin: "Paga con extracoin",
  coupon: "Buono di Registrazione",
  iHaveInviteCoupon: "Ho un coupon di invito",
  enterInviteCoupon: "Inserisci il codice del coupon di invito",
  inviteCouponRequired: "Inserisci il codice del coupon di invito.",
  uploadDocPic: "Carica la foto del documento",
  on: "su",
  salePromoterRefExplanation:
    "Puoi registrarti come Promoter solo tramite un link di riferimento da un Manager.",
  // toast,
  referralUserNotFound: "Utente di riferimento non trovato.",
  invalidCoupon: "Coupon di credito non valido.",
  couponDoesNotBelong: "Il coupon non appartiene a questo utente referente.",
  genericError: "Si è verificato un errore. Per favore, riprova.",
  passwordMin8: "La password deve contenere almeno 8 caratteri.",
  pleaseReverify: "Si prega di completare la verifica ReCAPTCHA.",
  paymentCheckout: "Pagamento",
  phoneConfirmation: "Conferma telefonica",
  phoneConfirmCodeExplanationPt1: "Abbiamo inviato un messaggio via SMS a",
  phoneConfirmCodeExplanationPt2:
    "con il tuo codice di conferma, inserisci il codice qui sotto per completare la registrazione.",
  phoneConfirmCode: "Codice di conferma",
  pleaseUploadDocPic: "Carica una foto del tuo documento d'identità",
  shippingRules: "Avviso: Non è ancora possibile utilizzare il preventivo di spedizione!",
  shippingRulesExplanation:
    "Il nostro servizio di spedizione è disponibile solo per gli utenti che spedicono da indirizzi in Italia!",
  iKnow: "Sono consapevole",
  alreadyHaveAccount: "Hai già un account?",
  emailCanBeSpam: "Controlla la tua cartella spam, l'email potrebbe esserci.",
  doubts: "Dubbi?",
  payNow: "Paga ora",
  doLogin: "Accedi",
  termsAndConditions: "Termini e condizioni",
  createFreeAccount: "Crea account gratuito",
  youAreRegistering: "Ti stai registrando come",
  createAccount: "Crea account",
  registrationSuccessActivateYourAccount:
    "Registrazione completata con successo! Controlla la tua email per attivare il tuo account.",
  loginAndContinuePurchase: "Accedi e continua il tuo acquisto",
  customerRegisterTitle: "Inizia a guadagnare di più con quello che già compri.",
  customerRegisterDescription:
    "Come Cliente Extraconomy, ogni acquisto può tornare a te sotto forma di Extracréditi, un credito complementare che usi come parte del pagamento all'interno della piattaforma.",
  customerRegisterSubtitle: "Ricevi Extracréditi ogni volta che acquisti da partner Extraconomy.",
  registerRoleCustomer: "CUSTOMER",
  registerRoleStore: "STORE",
  registerRoleManager: "MANAGER",
  registerRoleManagerAssociation: "MANAGER ASSOCIATION",
  registerRolePartner: "PARTNER",
  registerRoleSeller: "SELLER",
  registerRolePromoter: "PROMOTER",
  managerRegisterTitle: "Espandi la tua influenza come Manager.",
  managerRegisterDescription:
    "Come Manager, costruisci e guidi una rete di business, collegando persone e aziende in un'economia collaborativa.",
  managerRegisterSubtitle: "Guida. Connetti. Trasforma la tua regione.",
  managerRegisterSubtitleAssociation:
    "Ti stai registrando come Manager Association. Carica il documento dell'associazione per completare la registrazione.",
  associationPdfLabel: "Documento dell'associazione (PDF)",
  associationPdfRequired: "Carica il documento PDF dell'associazione per continuare.",
  associationPdfInvalidType: "Il file deve essere un PDF.",
  associationPdfTooLarge: "Il file PDF deve essere al massimo di 10 MB.",
  removeFile: "Rimuovi",
  storeRegisterTitle: "Porta il tuo negozio fisico nel digitale con Extraconomy.",
  storeRegisterDescription:
    "La registrazione Store è gratuita e ti prepara ad attivare le vendite online con il piano Start Seller quando vuoi.",
  storeRegisterSubtitle: "Crea il tuo account Store e passa al marketplace al tuo ritmo.",
  promoterRegisterTitle1: "Diventa un Promoter.",
  promoterRegisterTitle2: "Connetti, Cresci, Trasforma.",
  promoterRegisterDescription:
    "In Extraconomy, ogni connessione conta. Offri consulenza, connetti aziende, genera opportunità e costruisci un'economia collaborativa che valorizza le persone e risultati sostenibili.",
  promoterRegisterSubtitle: "Costruisci impatto. Genera valore. Sii parte del cambiamento.",
  partnerRegisterTitle: "Diventa Partner. Condividi, Cresci, Valorizza.",
  partnerRegisterDescription:
    "Entra nella rete Extraconomy dedicata ai professionisti. Crea la tua vetrina digitale, promuovi i tuoi servizi commerciali e costruisci connessioni di valore che trasformano il networking in opportunità concrete e ricavi condivisi.",
  partnerRegisterSubtitle: "Crea rete. Sviluppa il tuo business. Sii parte del cambiamento.",
  sellerRegisterTitle: "Lancia il tuo e-commerce su Extraconomy. Vendere, Scalare, Digitalizzare.",
  sellerRegisterDescription:
    "Entra nella rete digitale progettata per chi vende online. Attiva la tua piattaforma di e-commerce, gestisci i tuoi prodotti con totale autonomia e aumenta le vendite verso nuovi mercati con commissioni giuste e competitive.",
  sellerRegisterSubtitle: "Vendi ovunque. Massimizza i tuoi profitti. Sii parte del cambiamento.",
  registerSEODescription:
    "Registrati su Extraconomy per accedere al tuo account, espandere la tua rete e sfruttare opportunità esclusive di business.",
  createYourAccount: "Crea il tuo account",
};

export default registerUserDictIT;
